export default __webpack_public_path__ + "static/media/YFI-USDT.d817eda8.svg";